export default __webpack_public_path__ + "static/media/leichty.9da2564e.jpg";